import { createFileRoute } from '@tanstack/react-router'
import { AgentMonitorPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/monitor')({
  component: AgentMonitorPage,
})
